import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Grid2, Paper, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';

import { postPayment } from '../pos/PosSlice';
import { isEmpty } from '../../utils/Utils';

function PostPayment () {
    const { user } = useSelector((state) => state.account);
    const { payment_details } = useSelector((state) => state.mpPos);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [paymentDetails, setPaymentDetails] = useState({});

    useEffect(() => {
        setPaymentDetails({
            amount: payment_details?.amount,
            currency: payment_details?.currency,
            reference: `SoftPOS-${payment_details.reservation_id}-${Date.now()}`
        })
    }, [payment_details, setPaymentDetails]);

    const handlePostPayment = () => {
        dispatch(postPayment(paymentDetails));
        navigate('/pos/verify/');
    }

    return (
        <Paper sx={{ padding: 2}}>
            <Grid2 container spacing={3} alignItems='center' justifyContent='center'>
                <Grid2 size={{ xs: 12 }} sx={{ mt: 3, mb: 2}} display='flex' justifyContent='center' alignItems='center'>   
                    { !isEmpty(paymentDetails) && 
                        <Button 
                            href={`https://app.mobipaid.com/softpos?amount=${paymentDetails.amount}&reference=${paymentDetails.reference}`}
                            variant='contained' 
                            color='primary'
                        >Open SoftPOS</Button>
                    }
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <Typography variant='caption'>Return to this screen after payment is completed on SoftPOS to post the transaction to {`${user.app}`}</Typography>
                </Grid2>
                <Grid2 size={{ xs: 12 }} display='flex' justifyContent='flex-start'>
                    <Button onClick={handlePostPayment} variant='contained' color='success' endIcon={<SendIcon />}>Post to {`${user.app}`}</Button>
                </Grid2>
                <Grid2 size={{ xs: 12, marginTop: '15px' }} display='flex' justifyContent='flex-end'>
                    <Button onClick={() => navigate('/')} variant='outlined' color='error' endIcon={<CancelScheduleSendIcon />} >Cancel</Button>
                </Grid2>
            </Grid2>
        </Paper>
    )
}

export default PostPayment;